import { render, staticRenderFns } from "./SigningUpCertificateSupervisor.vue?vue&type=template&id=d9706b8a&scoped=true"
import script from "./SigningUpCertificateSupervisor.vue?vue&type=script&lang=ts"
export * from "./SigningUpCertificateSupervisor.vue?vue&type=script&lang=ts"
import style0 from "./SigningUpCertificateSupervisor.vue?vue&type=style&index=0&id=d9706b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9706b8a",
  null
  
)

export default component.exports